/* Dress My Paws – theme.js (vanilla, no dependencies) */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  };

  /* ---------- Mobile menu ---------- */
  var burger = $('[data-menu-toggle]'), nav = $('[data-nav]');
  if (burger && nav) burger.addEventListener('click', function () {
    var open = nav.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open);
  });

  /* ---------- Cart drawer ---------- */
  var drawer = $('#cart-drawer');
  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); refreshCart().then(openDrawer); }
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function updateShipbar(total) {
    var bar = $('[data-shipbar]'); if (!bar) return;
    var t = parseInt(bar.dataset.threshold, 10), left = t - total;
    var txt = $('[data-shipbar-text]', bar), fill = $('[data-shipbar-fill]', bar);
    txt.textContent = left > 0 ? 'You are ' + money(left) + ' away from FREE shipping!' : '🎉 You unlocked FREE shipping!';
    fill.style.width = Math.min(100, Math.round(total / t * 100)) + '%';
  }

  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        $$('[data-cart-total]').forEach(function (el) { el.textContent = money(cart.total_price); });
        updateShipbar(cart.total_price);
        return fetch('/cart?view=')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-cart-items]');
            var target = $('[data-cart-items]');
            if (fresh && target) target.innerHTML = fresh.innerHTML;
            else if (target) target.innerHTML = renderLines(cart);
          });
      });
  }
  function renderLines(cart) {
    if (!cart.items.length) return '<div class="cart-empty"><p>Your cart is empty. Time to find a spooky outfit!</p></div>';
    return '<ul class="cart-lines">' + cart.items.map(function (i, idx) {
      return '<li class="cart-line"><a class="cart-line__img" href="' + i.url + '"><img src="' + (i.image || '') + '" alt="" width="80" loading="lazy"></a>' +
        '<div class="cart-line__info"><a class="cart-line__title" href="' + i.url + '">' + i.product_title + '</a>' +
        (i.variant_title ? '<p class="cart-line__variant">' + i.variant_title + '</p>' : '') +
        '<p class="cart-line__price">' + money(i.final_line_price) + '</p>' +
        '<div class="qty"><button type="button" data-qty-minus data-line="' + (idx + 1) + '">&minus;</button><span>' + i.quantity + '</span><button type="button" data-qty-plus data-line="' + (idx + 1) + '">+</button></div></div>' +
        '<button type="button" class="cart-line__remove" data-remove data-line="' + (idx + 1) + '">Remove</button></li>';
    }).join('') + '</ul>';
  }
  function changeLine(line, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (document.body.classList.contains('template-cart')) { location.reload(); return; }
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        $$('[data-cart-total]').forEach(function (el) { el.textContent = money(cart.total_price); });
        updateShipbar(cart.total_price);
        var target = $('[data-cart-items]'); if (target) target.innerHTML = renderLines(cart);
      });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-minus],[data-qty-plus],[data-remove]'); if (!b) return;
    var line = parseInt(b.dataset.line, 10), row = b.closest('.cart-line'), q = parseInt($('.qty span', row).textContent, 10);
    if (b.hasAttribute('data-remove')) changeLine(line, 0);
    else changeLine(line, b.hasAttribute('data-qty-plus') ? q + 1 : q - 1);
  });

  /* ---------- Ajax add-to-cart (cards + product form) ---------- */
  function addToCart(form) {
    var btn = $('[type=submit]', form); if (btn) btn.disabled = true;
    var err = $('[data-error]', form); if (err) err.hidden = true;
    return fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshCart(); })
      .then(openDrawer)
      .catch(function (j) { if (err) { err.textContent = (j && j.description) || 'Could not add to cart.'; err.hidden = false; } })
      .then(function () { if (btn) btn.disabled = false; });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-ajax-add]') || f.matches('#product-form')) {
      if (e.submitter && e.submitter.name === 'checkout') return;
      e.preventDefault(); addToCart(f);
    }
  });

  /* ---------- Product page ---------- */
  var prod = $('[data-product]');
  if (prod) {
    var data = JSON.parse($('[data-product-json]', prod).textContent);
    var form = $('#product-form'), idInput = $('[data-variant-id]', form);
    var atc = $('[data-atc]', form), label = $('[data-atc-label]', form);
    function selected() {
      return $$('.opt', form).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function sync() {
      var sel = selected();
      var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      if (!v) { atc.disabled = true; label.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      atc.disabled = !v.available;
      label.textContent = v.available ? 'Add to cart' : 'Sold out';
      var p = $('[data-price]'); if (p) { var s = $('strong', p); if (s) s.textContent = money(v.price); }
      var sp = $('[data-sticky-price]'); if (sp) sp.textContent = money(v.price);
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      if (v.featured_image) {
        var idx = data.media ? data.media.findIndex(function (m) { return m.id === v.featured_media.id; }) : -1;
        if (idx > -1) showMedia(idx);
      }
    }
    form.addEventListener('change', function (e) { if (e.target.closest('.opt')) sync(); });

    function showMedia(i) {
      $$('.gallery__item').forEach(function (el) { el.classList.toggle('is-active', +el.dataset.media === i); });
      $$('[data-thumb]').forEach(function (el) { el.classList.toggle('is-active', +el.dataset.thumb === i); });
    }
    $$('[data-thumb]').forEach(function (b) { b.addEventListener('click', function () { showMedia(+b.dataset.thumb); }); });

    var qin = $('input[name=quantity]', form);
    var dec = $('[data-qty-dec]'), inc = $('[data-qty-inc]');
    if (dec) dec.addEventListener('click', function () { qin.value = Math.max(1, +qin.value - 1); });
    if (inc) inc.addEventListener('click', function () { qin.value = +qin.value + 1; });

    var sticky = $('[data-sticky-atc]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(atc);
      $('[data-sticky-trigger]').addEventListener('click', function () { form.requestSubmit(); });
    }
  }

  /* ---------- Product recommendations ---------- */
  var recs = $('[data-recs]');
  if (recs && !recs.children.length) {
    fetch(recs.dataset.url).then(function (r) { return r.text(); }).then(function (t) {
      var d = new DOMParser().parseFromString(t, 'text/html'), n = d.querySelector('[data-recs]');
      if (n && n.innerHTML.trim()) recs.innerHTML = n.innerHTML;
    }).catch(function () {});
  }

  /* ---------- Collection sort & filters ---------- */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); location.href = u; });
  var ff = $('[data-filter-form]');
  if (ff) ff.addEventListener('submit', function (e) {
    e.preventDefault();
    var p = new URLSearchParams(new FormData(ff)), u = new URL(location.href);
    Array.from(u.searchParams.keys()).filter(function (k) { return k.indexOf('filter.') === 0; }).forEach(function (k) { u.searchParams.delete(k); });
    p.forEach(function (v, k) { if (v !== '') u.searchParams.append(k, v); });
    u.searchParams.delete('page'); location.href = u;
  });

  /* ---------- Countdown ---------- */
  var cd = $('[data-countdown]');
  if (cd) {
    var target = new Date(cd.dataset.countdown).getTime();
    var tick = function () {
      var diff = Math.max(0, target - Date.now());
      var pad = function (n) { return String(n).padStart(2, '0'); };
      $('[data-d]', cd).textContent = pad(Math.floor(diff / 864e5));
      $('[data-h]', cd).textContent = pad(Math.floor(diff % 864e5 / 36e5));
      $('[data-m]', cd).textContent = pad(Math.floor(diff % 36e5 / 6e4));
      $('[data-s]', cd).textContent = pad(Math.floor(diff % 6e4 / 1e3));
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Cookie consent (Shopify Customer Privacy API) ---------- */
  var banner = $('#dmp-cookie');
  if (banner) {
    var KEY = 'dmp_consent_v1';
    var saved = null; try { saved = JSON.parse(localStorage.getItem(KEY)); } catch (e) {}
    var panel = $('[data-cookie-panel]', banner);
    function apply(c) {
      try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {}
      if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
        Shopify.customerPrivacy.setTrackingConsent({
          analytics: c.analytics, marketing: c.marketing, preferences: c.preferences,
          sale_of_data: c.marketing
        }, function () {});
      }
      banner.hidden = true;
    }
    function init() { if (!saved) banner.hidden = false; }
    if (window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { init(); });
    } else init();

    banner.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-cookie-accept]')) apply({ analytics: true, marketing: true, preferences: true });
      else if (t.closest('[data-cookie-decline]')) apply({ analytics: false, marketing: false, preferences: false });
      else if (t.closest('[data-cookie-prefs]')) panel.hidden = !panel.hidden;
      else if (t.closest('[data-cookie-save]')) apply({ analytics: $('[data-cookie-analytics]', banner).checked, marketing: $('[data-cookie-marketing]', banner).checked, preferences: $('[data-cookie-prefs-cb]', banner).checked });
      else if (t.closest('[data-cookie-donotsell]')) { e.preventDefault(); apply({ analytics: false, marketing: false, preferences: false }); }
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cookie-reopen]')) { e.preventDefault(); banner.hidden = false; panel.hidden = false; }
    });
  }
})();
